import { BadgeInput } from './badge-input'

export default BadgeInput
